import { Box, Spinner } from "@chakra-ui/react";
import React from "react";
import { Navigate, Outlet } from "react-router-dom";
import { useAuth } from "../../../hooks";
import { ROUTE_DASHBOARD } from "../../../navigation/routes";

/**
 * Renders the login layout
 * 
 * @returns The login layout
 */
const LoginLayout = () => {
  const auth = useAuth();

  if (!auth.loading && auth.user) {
    return <Navigate to={ROUTE_DASHBOARD} />;
  }

  return (
    <Box
      alignItems={"center"}
      display={"flex"}
      flexDirection={"row"}
      height={"100vh"}
      justifyContent={"center"}
    >
      {auth.loading ? <Spinner /> : <Outlet />}
    </Box>
  );
};

export default React.memo(LoginLayout);
